export const Monogram = ({ className = "", size = "md" }) => {
  const sizes = {
    sm: "h-9 w-9",
    md: "h-11 w-11",
    lg: "h-16 w-16",
  };
  return (
    <img
      src="/logo-white.png"
      alt="Shuten Tattoo Studio logó"
      data-testid="brand-monogram"
      className={`inline-block select-none object-contain ${sizes[size]} ${className}`}
    />
  );
};
